import styled, { css } from 'styled-components';
import { ShopStyled } from '../../shopSetting/assets/shopStyled';
import { MarketplaceStyled } from '../../marketplace/assets/marketplaceStyle';
import { ScavengerStyled } from '../../scavengerHunt/assets/scavengerStyle';
import { Modal } from 'react-bootstrap';

export const HeaderFilter = styled(ScavengerStyled.HeaderFilter)`
  .filter-part-main {
    gap: 13px;
    @media screen and (max-width: 767px) {
      gap: 8px;
    }
  }
  .search-bar {
    width: 230px;
    @media screen and (max-width: 854px) {
      width: 200px;
    }
    @media screen and (max-width: 767px) {
      width: auto;
      flex-grow: 1;
    }
  }
  .category {
    width: 153px;
    .menu-toggle {
      height: 30px;
    }
    @media screen and (max-width: 854px) {
      width: 122px;
    }
    @media screen and (max-width: 767px) {
      display: none;
    }
  }

  .reset-filter-btn {
    width: 96px;
    @media screen and (max-width: 767px) {
      width: auto;
    }

    .filter-icon-button {
      @media screen and (max-width: 767px) {
        padding: 6px 8px;
        svg {
          width: 14px;
          height: 14px;
        }
      }
    }
  }
  .search-category-part {
    gap: 13px;
    @media screen and (max-width: 767px) {
      flex-grow: 1;
      width: auto;
    }
  }
  .filter-buttons {
    display: flex;
    gap: 13px;
  }
  .add-product-btn {
    width: 109px;
    button {
      font-weight: 400;
    }
    @media screen and (max-width: 767px) {
      display: none;
    }
  }
`;

export const ProductsTable = styled(ShopStyled.PolicyTable)`
  overflow-x: auto;
  font-family: ${({ theme }) => theme.fontFamily};
  border: 0;
  padding: ${({ padding }) => padding || '0'};
  //box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.36), 0 -3px 4px 0 rgba(0, 0, 0, 0.16);
  box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.11), 0 8px 16px 0 rgba(0, 0, 0, 0.12);
  @media screen and (max-width: 767px) {
    overflow-x: hidden;
    background: transparent;
    border: 0;
    margin-top: 0;
    box-shadow: unset;
    tbody {
      background: transparent;
    }
  }
  .table {
    @media screen and (max-width: 767px) {
      display: block;
    }
  }
  border-color: ${({ theme }) => theme.inputBorder};
  .product {
    display: flex;
    align-items: center;
    img {
      height: 72px;
      width: 72px;
      border-radius: 4px;
      @media screen and (max-width: 575px) {
        height: 24px;
        width: 24px;
      }
    }
    span {
      margin-left: 8px;

      display: flex;
      white-space: pre-wrap;
      a {
        color: inherit !important;
      }
    }
  }

  thead {
    @media screen and (max-width: 767px) {
      display: none;
    }
    tr {
      @media screen and (max-width: 767px) {
        display: block;
      }

      th {
        @media screen and (max-width: 767px) {
          display: block;
          padding: 10px 16px;
          border: 0;
          white-space: break-spaces;
        }

        padding: 24px;
        white-space: nowrap;
      }
    }
  }

  tbody {
    @media screen and (max-width: 767px) {
      display: block;
      width: 100%;
    }
    tr {
      @media screen and (max-width: 767px) {
        display: block;
        margin-bottom: 12px;
        background: #fff;
        border: 1.5px solid #efefef;
        border-radius: 8px;
        overflow: hidden;
      }
      .collapsed-plus-icon {
        margin-right: 0;
        display: none;
        @media screen and (max-width: 767px) {
          display: block;
        }
      }
      td {
        vertical-align: middle;
        padding-block: 12px;
        font-weight: 500;
        padding: 12px 24px;
        color: ${({ theme }) => theme.bodyMedium};
        &._wrap-text {
          overflow-wrap: anywhere;
          white-space: normal;
        }
        svg {
          cursor: pointer;
        }

        @media screen and (max-width: 767px) {
          display: flex;
          font-weight: 500;
          white-space: break-spaces;
          padding: 10px 16px;
          align-items: center;
          line-break: anywhere;
          &:nth-child(odd),
          &:nth-child(even) {
            background: #fff;
          }
        }
        &:last-child {
          @media screen and (max-width: 767px) {
            border-top: 1px solid #e3e3e3;
            margin-top: 6px;
            padding-top: 17px;
            padding-bottom: 17px;
          }
          .margin-right {
            margin-right: 12px;
          }
        }
        &:nth-child(4) {
          @media screen and (max-width: 767px) {
            align-items: start;
          }
        }
        &:nth-child(6) {
          font-weight: 400;

          @media screen and (max-width: 575px) {
            .present-button {
              font-size: 12px;
              padding: 4px 9px;
              line-height: 15px;
            }
          }
        }
        &:first-child {
          @media screen and (max-width: 767px) {
            border-bottom: 1px solid #e3e3e3;
            margin-bottom: 6px;
            padding: 16px;
            justify-content: space-between;
          }
        }

        .product-information-heading {
          min-width: 117px;
          margin-left: 0;
          font-size: 14px;
          line-height: 18px;
          font-weight: 400;
          @media screen and (max-width: 360px) {
            min-width: 100px;
          }
        }
      }
      ${MarketplaceStyled.Category} {
        padding: 7px 14px;
        border-radius: 30px;
        font-size: 14px;
      }
    }
  }
  .table-head-collapsed-icon {
    display: none;
    @media screen and (max-width: 767px) {
      display: block;
    }
    svg {
      color: ${({ theme }) => theme.primary};
    }
  }
  .product-table-pagination {
    padding: 0px 24px;
    .custom-drop-down {
      min-width: 116px;
      .menu-toggle {
        h6 {
          font-size: 16px;
        }
      }
    }
  }
  .first-td-checkbox {
    align-items: center;

    img,
    p {
      display: none;
      margin-bottom: 0;
      @media screen and (max-width: 767px) {
        display: block;
      }
    }

    @media screen and (max-width: 767px) {
      display: flex;
    }
    img {
      width: 24px;
      height: 24px;
      border-radius: 100%;
      margin-left: 12px;
      margin-right: 6px;
    }
    span {
      margin-right: 10px;
    }
  }
`;

export const FilterModal = styled(Modal)`
  .modal-body {
    padding: 24px 13px 13px 13px;
    color: ${({ theme }) => theme.primaryDark};
    overflow: hidden;
    .model-inner-content {
      height: calc(100% - 94px);
      overflow: auto;
      overflow-x: hidden;
    }
    .filter-heading-main {
      margin-bottom: 23px;
      h4 {
        font-size: 18px;
        font-weight: 500;
        line-height: 22.33px;
        margin: 0;
        color: ${({ theme }) => theme.primaryDark};
      }
    }
    .filter-category-lists {
      margin-bottom: 24px;
      padding-bottom: 0;
      padding-top: 0;
      display: block;
      &::before {
        display: none;
      }
    }
    .filter-lists {
      padding-bottom: 24px;
      &::before {
        position: static !important;
      }
    }
    .selected-category-button {
      padding: 6px 16px;
      display: flex;
      align-items: center;
      font-size: 12px;
      line-height: 15px;
      font-weight: 400;
      margin-bottom: 17px;
      border-radius: 6px;
      svg {
        width: 18px;
        height: 18px;
        margin-left: 11px;
      }
    }
    .category-heading {
      font-size: 14px;
      font-weight: 500;
      line-height: 17.5px;
      margin-bottom: 12px;
    }
    .category-radio-group {
      gap: 16px;
      max-height: 240px;
      overflow-y: auto;
      overflow-x: hidden;

      label {
        width: 100%;
        .radio-field-label {
          font-size: 12px;
          line-height: 15px;
          margin-left: 12px !important;
        }
      }
    }
    .reset-apply-button {
      padding-top: 12px;
      border-top: 1px solid #eaeaea;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .reset-button {
      background: transparent;
      border: none;
      margin: 0;
      padding: 0;
      color: ${({ theme }) => theme.primaryDark};
      &:hover {
        background-color: transparent !important;
      }
    }
    .Apply-button {
      border-radius: 81px;
      padding: 9px 19px;
    }
  }
`;

export const SelectAll = styled.div`
  border: 1.5px solid #efefef;
  border-radius: 8px;
  padding: 15px 16px;
  margin-bottom: 12px;
  background-color: ${({ theme }) => theme.white};
  justify-content: space-between;
  display: none;
  @media screen and (max-width: 767px) {
    display: flex;
  }
  .select-all-checkbox {
    display: flex;
    align-items: center;
    p {
      font-size: 14px;
      line-height: 18px;
      font-weight: 400;
      margin-left: 12px;
      margin-bottom: 0;
      color: ${({ theme }) => theme.primaryDark};
    }
  }
  .select-icons {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 16px;
    svg {
      color: ${({ theme }) => theme.primary};
      cursor: pointer;
    }
  }
`;

export const TableBodyRow = styled.tr`
  ${({ collapsed }) =>
    collapsed &&
    css`
      td {
        @media screen and (max-width: 767px) {
          &:not(:first-child) {
            display: none;
          }
          &:first-child {
            border: none !important;
            margin-bottom: 0 !important;
          }
        }
      }
    `}
`;

export const StyledProduct = {
  HeaderFilter,
  ProductsTable,
  FilterModal,
  SelectAll,
  TableBodyRow,
};
